(() => {
  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.initialized === 'true') return;

    gallery.dataset.initialized = 'true';

    const thumbs = Array.from(
      gallery.querySelectorAll('[data-ow-gallery-thumb]')
    );

    const items = Array.from(
      gallery.querySelectorAll('[data-ow-gallery-item]')
    );

    const prevButton = gallery.querySelector('[data-ow-gallery-prev]');
    const nextButton = gallery.querySelector('[data-ow-gallery-next]');
    const counter = gallery.querySelector('[data-ow-gallery-current]');
    const stage = gallery.querySelector('[data-ow-gallery-stage]');
const isMobileGallery = () =>
  window.matchMedia('(max-width: 749px)').matches;
    const modal = gallery.parentElement?.querySelector(
      '[data-ow-gallery-modal]'
    );

    const modalContent = modal?.querySelector(
      '[data-ow-gallery-modal-content]'
    );

    const closeButton = modal?.querySelector(
      '[data-ow-gallery-close]'
    );

    let activeIndex = Math.max(
      0,
      thumbs.findIndex((thumb) => thumb.classList.contains('is-active'))
    );

    const activateMedia = (index) => {
      if (!thumbs.length || !items.length) return;

      activeIndex = (index + thumbs.length) % thumbs.length;

      const activeThumb = thumbs[activeIndex];
      const mediaId = activeThumb.dataset.owGalleryThumb;

      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === activeIndex;

        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      items.forEach((item) => {
  const isActive = item.dataset.owGalleryItem === mediaId;

  item.classList.toggle('is-active', isActive);

  if (isMobileGallery()) {
    item.hidden = false;
  } else {
    item.hidden = !isActive;
  }
});

      if (counter) {
        counter.textContent = String(activeIndex + 1);
      }

      if (window.matchMedia('(min-width: 750px)').matches) {
  activeThumb.scrollIntoView({
    behavior: 'smooth',
    block: 'nearest',
    inline: 'nearest'
  });
}
    };
/* Update counter while swiping mobile gallery */
if (stage) {
  let scrollTimer;

  stage.addEventListener('scroll', () => {
    if (!isMobileGallery()) return;

    clearTimeout(scrollTimer);

    scrollTimer = setTimeout(() => {
      const stageRect = stage.getBoundingClientRect();
      const stageCenter = stageRect.left + stageRect.width / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.left + rect.width / 2;
        const distance = Math.abs(itemCenter - stageCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      activeIndex = closestIndex;

      if (counter) {
        counter.textContent = String(activeIndex + 1);
      }
    }, 60);
  }, { passive: true });
}
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        activateMedia(index);
      });
    });

    prevButton?.addEventListener('click', () => {
      activateMedia(activeIndex - 1);
    });

    nextButton?.addEventListener('click', () => {
      activateMedia(activeIndex + 1);
    });

    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        activateMedia(activeIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        activateMedia(activeIndex + 1);
      }

      if (event.key === 'Escape' && modal?.open) {
        modal.close();
      }
    });

  

    gallery.querySelectorAll('[data-ow-youtube-play]').forEach((button) => {
      button.addEventListener('click', () => {
        const preview = button.closest('[data-ow-youtube-preview]');
        if (!preview) return;

        const videoId = preview.dataset.videoId;
        if (!videoId) return;

        const iframe = document.createElement('iframe');

        iframe.src =
          `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;

        iframe.title = 'Product video';
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';

        iframe.allowFullscreen = true;
        iframe.loading = 'eager';

        preview.innerHTML = '';
        preview.appendChild(iframe);
        preview.classList.add('is-playing');
      });
    });

    gallery.querySelectorAll('[data-ow-gallery-zoom]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!modal || !modalContent) return;

        const image = button.querySelector('img');
        if (!image) return;

        modalContent.innerHTML = '';

        const enlarged = image.cloneNode(true);

        enlarged.removeAttribute('loading');
        enlarged.alt = image.alt;

        modalContent.appendChild(enlarged);
        modal.showModal();
      });
    });

    closeButton?.addEventListener('click', () => {
      modal?.close();
    });

    modal?.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.close();
      }
    });

   if (isMobileGallery()) {
  items.forEach((item) => {
    item.hidden = false;
    item.classList.remove('is-active');
  });

  if (items[0]) {
    items[0].classList.add('is-active');
  }

  activeIndex = 0;

  if (counter) {
    counter.textContent = '1';
  }

  requestAnimationFrame(() => {
    if (stage) {
      stage.scrollLeft = 0;
    }
  });
} else {
  activateMedia(activeIndex);
}
  };

  const initAll = () => {
    document.querySelectorAll('[data-ow-gallery]').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
const initMobileGalleries = () => {
  document.querySelectorAll('[data-ow-mobile-gallery]').forEach((gallery) => {
    if (gallery.dataset.mobileReady === 'true') return;
    gallery.dataset.mobileReady = 'true';

    const track = gallery.querySelector('[data-ow-mobile-track]');
    const slides = Array.from(
      gallery.querySelectorAll('.ow-gallery-mobile__slide')
    );
    const counter = gallery.querySelector('[data-ow-mobile-current]');

    const modal = gallery.parentElement?.querySelector(
      '[data-ow-gallery-modal]'
    );

    const modalContent = modal?.querySelector(
      '[data-ow-gallery-modal-content]'
    );

    if (!track || !slides.length) return;

    /* Start on first image */
    track.scrollLeft = 0;

    if (counter) {
      counter.textContent = '1';
    }

    /* Update 1/5 counter while swiping */
    let ticking = false;

    track.addEventListener(
      'scroll',
      () => {
        if (ticking) return;

        ticking = true;

        requestAnimationFrame(() => {
          const trackRect = track.getBoundingClientRect();
          const trackCenter = trackRect.left + trackRect.width / 2;

          let closestIndex = 0;
          let closestDistance = Infinity;

          slides.forEach((slide, index) => {
            const rect = slide.getBoundingClientRect();
            const slideCenter = rect.left + rect.width / 2;
            const distance = Math.abs(slideCenter - trackCenter);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          if (counter) {
            counter.textContent = String(closestIndex + 1);
          }

          ticking = false;
        });
      },
      { passive: true }
    );

    /* Tap image to enlarge */
    gallery.querySelectorAll('[data-ow-mobile-zoom]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!modal || !modalContent) return;

        const image = button.querySelector('img');
        if (!image) return;

        modalContent.innerHTML = '';

        const enlarged = image.cloneNode(true);
        enlarged.removeAttribute('loading');
        enlarged.alt = image.alt;

        modalContent.appendChild(enlarged);
        modal.showModal();
      });
    });
  });
};

initMobileGalleries();

document.addEventListener(
  'shopify:section:load',
  initMobileGalleries
);
})();